<ul class="breadcrumb" *ngIf="environmentSettings.PSS">
    <li>
      <a [routerLink]="['/']">Home</a>
    </li>
    <li>Director</li>
  </ul>
  <section class="card">
    <div class="card-header">
      <span class="cat__core__title">
        <strong id="pageTitle">Directors</strong>
      </span>
      <span style="float: right" >
        <a routerLink="/director/add" *ngIf="environmentSettings.PSS">
          <button class="btn btn-success pull-right" class="btn btn-sm btn-primary mb-2" type="button">
            <i class="fa fa-plus"></i>&nbsp;Add Director</button>
        </a>
  
        <!-- <button type="button"
          [appHasPermission]="{'Url': '/register/director/edit?goveva=true&email=', 'method':'put', 'menu': 'Director'}"
          class="btn btn-sm btn-primary ml-2" (click)="generateMbp4bDocument();">
          <i class="fa fa-plus"></i>Generate Document (MBP 4B)</button> -->
      </span>
    </div>
    <div class="row">
      <div class="col-lg-12" id="directorTabContainer">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item">
            <a class="nav-link active" href="javascript: void(0);" data-toggle="tab" data-target="#director"
              role="tab">Director</a>
          </li>
          <!-- <li class="nav-item" style="display: none">
            <a class="nav-link" href="javascript: void(0);" data-toggle="tab" data-target="#registerDirector" role="tab" (click)="tabRegisterOfDirectorOnClickEvent();">Register of Director</a>
          </li> -->
        </ul>
        <div class="tab-content">
          <div class="tab-pane active" id="director" role="tabcard">
            <div class="modal-body">
              <!-- Date Filter  -->
              <section class="card search-box">
                <div class="card-header" (click)="toggleSearchDiv()" style="cursor: pointer;">Modify Search
                  <span class="pull-right">
                    <i class="fa fa-filter" aria-hidden="true"></i>
                  </span>
                </div>
                <div class="card-block collapse" id="search-div" [ngClass]="{'collapse': !isSearchDivVisible}">
                  <div class="row">
                    <div class="col-lg-12">
                      <form (document:click)="appDate.close();cesDate.close();">
                        <div class="row">
                          <div class="col-lg-2">
                            <label>From Date :
                            </label>
                            <div class="input-group" (click)="$event.stopPropagation()">
                              <input id="fromDatecal" [maxDate]="futureFromDate" class="form-control"
                                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dpAppointment"
                                ngbDatepicker #appDate="ngbDatepicker" (click)="appDate.toggle();cesDate.close();"
                                (ngModelChange)="setTodate($event)" [(ngModel)]="FromDateModelInMasterDirector">
                              <button class="input-group-addon" (click)="appDate.toggle();cesDate.close();" type="button">
                                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                              </button>
                            </div>
                          </div>
                          <div class="col-lg-2">
                            <label>To Date :
                            </label>
                            <div class="input-group" (click)="$event.stopPropagation()">
                              <input id="toDatecal" [minDate]="futureToDate" class="form-control"
                                style="padding:6px;z-index: 0;" placeholder="dd-mm-yyyy" name="dpCessation" ngbDatepicker
                                #cesDate="ngbDatepicker" (click)="cesDate.toggle();appDate.close();"
                                [(ngModel)]="ToDateModelInMasterDirector" (ngModelChange)="setFromdate($event)">
                              <button class="input-group-addon" (click)="cesDate.toggle();appDate.close();" type="button">
                                <span class="fa fa-calendar" style="width: 1.2rem; height: 1rem; cursor: pointer;"></span>
                              </button>
                            </div>
                          </div>
                          <div class="col-sm-2">
                            <label>&nbsp;&nbsp;&nbsp;</label>
                            <div class="input-group">
                              <button type="button" [disabled]="response" class="btn btn-sm btn-primary mb-2"
                                (click)="getDirectorByParam()">
                                <i class="fa fa-search"></i>&nbsp;Search</button>
                              &nbsp;&nbsp;&nbsp;
                              <button type="button" [disabled]="response" class="btn btn-sm btn-default mb-2"
                                (click)="getDirectorByNullParam()">
                                <i class="fa fa-refresh"></i>&nbsp;Clear</button>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </section>
              <!-- Date filter End -->
              <div class="card-block datatable-card-block">
                <div class="row">
                  <div class="col-md-12">
                    <div class="margin-bottom-50">
                      <div class="table-responsive">
                        <table datatable [dtOptions]="dtOptionsOfMasterDirector" [dtTrigger]="dtTriggerMasterDirector"
                          class="table table-hover compact cell-border nowrap stripe" id="directormasterTable"
                          style="cursor: pointer;">
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Designation</th>
  
                              <th>Date of cessation</th>
                              <th style="display: none">Date of cessation</th>
  
                              <th>Date of Appointment</th>
                              <th>Date of Board resolution</th>
                              <th style="display: none">Date of Appointment</th>
                              <th>Status</th>
                              <th class="actionclass">Action
                                <!-- <span [appHasPermission]="{'Url': '/register/director/edit?goveva=true&email=', 'method':'put', 'menu': 'Director'}">Action</span> -->
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let director of masterDirectorList;">
                              <td tabindex="1">{{director.FirstName}} {{director.MiddleName}} {{director.LastName}}</td>
                              <td>
                                <span *ngIf="director.DirectorProfession[0]!=null">
                                  {{director.DirectorProfession[0].Designation}}
                                </span>
                                <span *ngIf="director.DirectorProfession[0]==null">
                                  N/A
                                </span>
                              </td>
  
                              <td>
                                <span *ngIf="director.DirectorProfession[0]!=null">
                                  <span style="display: none">
                                    {{director.DirectorProfession[0].CessationDate | date : "yMMdd"}}</span>
                                  {{director.DirectorProfession[0].CessationDate | date : "dd-MM-y"}}
                                </span>
                                <span *ngIf="director.DirectorProfession[0]==null">
                                  N/A
                                </span>
                              </td>
                              <td style="display: none">
                                <span *ngIf="director.DirectorProfession[0]!=null">
                                  {{director.DirectorProfession[0].CessationDate | date : "dd-MM-y"}}
                                </span>
                                <span *ngIf="director.DirectorProfession[0]==null">
                                  N/A
                                </span>
                              </td>
  
  
  
  
  
  
  
                              <td>
                                <span *ngIf="director.DirectorProfession[0]!=null">
                                  <span style="display: none">
                                    {{director.DirectorProfession[0].AppointmentDate | date : "yMMdd"}}</span>
                                  {{director.DirectorProfession[0].AppointmentDate | date : "dd-MM-y"}}
                                </span>
                                <span *ngIf="director.DirectorProfession[0]==null">
                                  N/A
                                </span>
                              </td>
  
                              <td>
                                <span *ngIf="director.DirectorProfession[0]!=null">
                                  {{director.DirectorProfession[0].BoardResolutionDate | date : "dd-MM-y"}}
                                </span>
                                <span *ngIf="director.DirectorProfession[0]==null">
                                  N/A
                                </span>
                              </td>
  
                              <td style="display: none">
                                <span *ngIf="director.DirectorProfession[0]!=null">
                                  {{director.DirectorProfession[0].AppointmentDate | date : "dd-MM-y"}}
                                </span>
                                <span *ngIf="director.DirectorProfession[0]==null">
                                  N/A
                                </span>
                              </td>
                              <td>
                                <span *ngIf="director.Status==true">Active</span>
                                <span *ngIf="director.Status==false">Inactive </span>
                              </td>
                              <td style='white-space: nowrap'>
                                <a>
                                  <button type="button"
                                    [appHasPermission]="{'Url': '/register/director/edit?goveva=true&email=', 'method':'put', 'menu': 'Director'}"
                                    class="btn-sm btn btn-warning" (click)="loadDirectorDateById(director._id)">
                                    <span class="fa fa-pencil"></span>
                                  </button>
                                </a>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="tab-pane" id="registerDirector" role="tabcard">
            <div class="modal-body">
              <div class="dirBlk card-block datatable-card-block">
                <div class="row">
                  <div class="col-md-12">
                    <div class="margin-bottom-50">
                      <div class="table-responsive">
                        <table datatable [dtOptions]="dtOptionsOfRegisterDirector" [dtTrigger]="dtTriggerRegisterDirector" class="table table-hover compact cell-border nowrap stripe"
                          id="directorRegisterTable" style="cursor: pointer;">
                          <thead>
                            <tr>
                              <th>Director Name</th>
                              <th>DIN Number</th>
                              <th>Category</th>
                              <th>Designation</th>
                              <th>Authorization Status</th>
                              <th class="actionclass">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let director of registerDirectorList;let i=index">
                              <td tabindex="1">
                                {{director.FirstName}} {{director.MiddleName}} {{director.LastName}}
                              </td>
                              <td tabindex="1">
                                {{director.Din}}
                              </td>
                              <td tabindex="1">
                                <span *ngIf="director.DirectorProfession[0]!=undefined">
                                  {{director.DirectorProfession[0].Category}}
                                </span>
                                <span *ngIf="director.DirectorProfession[0]==undefined">
                                  N/A
                                </span>
                              </td>
                              <td tabindex="1">
                                <span *ngIf="director.DirectorProfession[0]!=undefined">
                                  {{director.DirectorProfession[0].Designation}}
                                </span>
                                <span *ngIf="director.DirectorProfession[0]==undefined">
                                  N/A
                                </span>
                              </td>
                              <td tabindex="1">
                                <span>{{director.authStatus}}</span>
                              </td>
                              <td style='white-space: nowrap'>
                                <span *ngIf="director.RegisterDirectorStatusList.indexOf('Unauthorized')>-1">
                                  <button type="button" class="btn btn-sm btn-outline-dark" (click)="loadauthorizeData(director._id)">
                                    <span class="fa fa-lock">
                                    </span>
                                  </button>&nbsp;&nbsp;&nbsp;</span>
                                <span *ngIf="director.RegisterDirectorStatusList.indexOf('Authorized')>-1">
                                  <button type="button" class="btn btn-sm btn-outline-dark" (click)="loadrectifyData(director._id)">
                                    <span class="fa fa-unlock"></span>
                                  </button>
                                </span>
                                <span *ngIf="director.RegisterDirectorStatusList.indexOf('Authorized')>-1">
                                  <button type="button" class="btn btn-sm btn-outline-dark" (click)="exportRegisterOfDirectorToPdf(director._id)">
                                    <span class="fa fa-download"></span>
                                  </button>
                                </span>
  
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
        </div>
      </div>
    </div>
  </section>